'use client';

import { DetailPageSkeleton } from '../detail-page-skeleton';

export function ReleaseDetailSkeleton() {
  return <DetailPageSkeleton metadataColumns={4} showImageGallery={true} />;
}
